import {
  NON_RECOGNIZED_USER,
  RECOGNIZED_USER_INSUFFICIENT_DATA,
  RECOGNIZED_USER_SUFFICIENT_DATA
} from 'constants/personalizationMarkerTypes';

import PersonalizationMarker from 'components/landing/PersonalizationMarker';

export function makePersonalizationMarker({ showOnMobile, isCustomerRecognized, isPersonalized, componentName, forcedAlignment, contents, shrinkOnTabletPortrait = false }, hydraPersonalizationMarker) {
  if (!hydraPersonalizationMarker) {
    return null;
  }

  const { icon: markerAlignment, contents: contentsAlignment } = forcedAlignment || {};

  const iconAlignment = markerAlignment ? markerAlignment : (hydraPersonalizationMarker === 2 ? 'right' : 'left');

  let type = NON_RECOGNIZED_USER;
  if (isCustomerRecognized) {
    type = isPersonalized ? RECOGNIZED_USER_SUFFICIENT_DATA : RECOGNIZED_USER_INSUFFICIENT_DATA;
  }

  return <PersonalizationMarker
    iconAlignment={iconAlignment}
    contentsAlignment={contentsAlignment}
    type={type}
    componentName={componentName}
    showOnMobile={showOnMobile}
    shrinkTooltipOnTabletPortrait={shrinkOnTabletPortrait}
    contents={contents}
  />;
}
